export type SpaceTeamProfile = {
  role: string;
  department: string;
};

export type SpacePlayerPresentation = {
  displayName: string;
  meta: string;
  profile: SpaceTeamProfile;
};

function normalize(value: string): string {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

const RULES: Array<{
  matches: string[];
  profile: SpaceTeamProfile;
}> = [
  {
    matches: [
      'matheus',
      'matheus afonso',
      'matheus afonso rodrigues',
      'space work admin',
    ],
    profile: {
      role: 'Closer',
      department: 'Closers',
    },
  },

  {
    matches: [
      'luis',
      'luiz',
      'luis eduardo',
      'luiz eduardo',
    ],
    profile: {
      role: 'Closer',
      department: 'Closers',
    },
  },

  {
    matches: [
      'felipe santos',
      'felipe closer',
    ],
    profile: {
      role: 'Closer',
      department: 'Closers',
    },
  },

  {
    matches: ['neto'],
    profile: {
      role: 'SDR',
      department: 'Pré-Vendas',
    },
  },

  {
    matches: ['luana'],
    profile: {
      role: 'SDR',
      department: 'Pré-Vendas',
    },
  },

  {
    matches: ['ayres'],
    profile: {
      role: 'SDR',
      department: 'Pré-Vendas',
    },
  },

  {
    matches: [
      'fabio',
      'fabio camargo',
      'guilherme',
      'guilherme davi',
      'gui',
    ],
    profile: {
      role: 'Gestão',
      department: 'Gestão',
    },
  },

  {
    matches: [
      'professor',
      'professora',
      'teacher',
    ],
    profile: {
      role: 'Professor',
      department: 'Professores',
    },
  },

  {
    matches: [
      'tech',
      'developer',
      'desenvolvedor',
    ],
    profile: {
      role: 'Tech / IA',
      department: 'Tech / IA',
    },
  },
];


export function resolveSpaceTeamProfile(
  rawName: string,
): SpaceTeamProfile {

  const value = normalize(rawName);

  for (const rule of RULES) {

    if (
      rule.matches.some((match) => {
        const normalizedMatch = normalize(match);

        return (
          value === normalizedMatch ||
          value.startsWith(normalizedMatch + ' ') ||
          value.includes(normalizedMatch)
        );
      })
    ) {
      return rule.profile;
    }

  }

  return {
    role: 'Equipe',
    department: 'Space',
  };
}


export function getSpacePlayerPresentation(
  rawName: string,
): SpacePlayerPresentation {

  const original =
    String(rawName || '').trim() || 'Usuário';

  const normalized = normalize(original);

  const profile =
    resolveSpaceTeamProfile(original);


  let displayName: string;

  // A conta administrativa atual é o Matheus.
  if (normalized === 'space work admin') {

    displayName = 'Matheus';

  } else if (original.includes('@')) {

    displayName =
      original
        .split('@')[0]
        .split(/[._-]/)[0] || 'Usuário';

  } else {

    displayName =
      original.split(/\s+/)[0] ||
      original;

  }


  displayName =
    displayName.charAt(0).toUpperCase() +
    displayName.slice(1);


  return {
    displayName,
    meta: `${profile.role} • 🟢 Online`,
    profile,
  };
}
